/**
 * @generated SignedSource<<3347d468cd388299e563aee3ca7eec9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asset_id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timetable",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v11 = [
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v13 = [
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zip",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "OpeningHours",
  "kind": "LinkedField",
  "name": "openingHours",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "from",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "until",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "TerminalInfo",
  "kind": "LinkedField",
  "name": "info",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "TerminalAgency",
  "kind": "LinkedField",
  "name": "agency",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "openingHoursText",
      "storageKey": null
    },
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "TerminalFacilityInfo",
  "kind": "LinkedField",
  "name": "facilityInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dangerousGoodsAllowed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parkingPossible",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dangerousGoodsStorageAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repairService",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cleaning",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reeferPlugsAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customsOnSite",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v26 = [
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v25/*: any*/)
],
v27 = [
  (v12/*: any*/),
  (v25/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "TagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Tag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "tags(first:20)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact1",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact2",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact3",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact4",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact5",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact6",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact7",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact8",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact9",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo1",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo2",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo3",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo4",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo5",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo6",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo7",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo8",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo9",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Terminal",
            "kind": "LinkedField",
            "name": "terminals",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              (v7/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "TagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Tag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v3/*: any*/),
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "tags(first:20)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact1",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact2",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact3",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact4",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact5",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact6",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact7",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact8",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickFact",
            "kind": "LinkedField",
            "name": "quickFact9",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo1",
            "plural": false,
            "selections": (v27/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo2",
            "plural": false,
            "selections": (v27/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo3",
            "plural": false,
            "selections": (v27/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo4",
            "plural": false,
            "selections": (v27/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo5",
            "plural": false,
            "selections": (v27/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo6",
            "plural": false,
            "selections": (v27/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo7",
            "plural": false,
            "selections": (v27/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo8",
            "plural": false,
            "selections": (v27/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailedInformation",
            "kind": "LinkedField",
            "name": "detailedInfo9",
            "plural": false,
            "selections": (v27/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Terminal",
            "kind": "LinkedField",
            "name": "terminals",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              (v7/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/)
            ],
            "storageKey": null
          },
          (v25/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d4a726284144ce83b725354c6c79760",
    "id": null,
    "metadata": {},
    "name": "ProductQuery",
    "operationKind": "query",
    "text": "query ProductQuery(\n  $slug: String!\n) {\n  product(slug: $slug) {\n    title\n    slug\n    asset_id\n    timetable\n    tags(first: 20) {\n      edges {\n        node {\n          name\n          slug\n          id\n        }\n      }\n    }\n    quickFact1 {\n      headline\n      note\n      icon\n      id\n    }\n    quickFact2 {\n      headline\n      note\n      icon\n      id\n    }\n    quickFact3 {\n      headline\n      note\n      icon\n      id\n    }\n    quickFact4 {\n      headline\n      note\n      icon\n      id\n    }\n    quickFact5 {\n      headline\n      note\n      icon\n      id\n    }\n    quickFact6 {\n      headline\n      note\n      icon\n      id\n    }\n    quickFact7 {\n      headline\n      note\n      icon\n      id\n    }\n    quickFact8 {\n      headline\n      note\n      icon\n      id\n    }\n    quickFact9 {\n      headline\n      note\n      icon\n      id\n    }\n    detailedInfo1 {\n      content\n      id\n    }\n    detailedInfo2 {\n      content\n      id\n    }\n    detailedInfo3 {\n      content\n      id\n    }\n    detailedInfo4 {\n      content\n      id\n    }\n    detailedInfo5 {\n      content\n      id\n    }\n    detailedInfo6 {\n      content\n      id\n    }\n    detailedInfo7 {\n      content\n      id\n    }\n    detailedInfo8 {\n      content\n      id\n    }\n    detailedInfo9 {\n      content\n      id\n    }\n    terminals {\n      active\n      name\n      info {\n        address\n        country\n        zip\n        city\n        phone\n        email\n        openingHours {\n          text\n          from\n          until\n        }\n      }\n      agency {\n        title\n        notes\n        openingHoursText\n        address\n        country\n        zip\n        city\n        phone\n        email\n        openingHours {\n          text\n          from\n          until\n        }\n      }\n      facilityInfo {\n        dangerousGoodsAllowed\n        parkingPossible\n        dangerousGoodsStorageAvailable\n        repairService\n        cleaning\n        reeferPlugsAvailable\n        customsOnSite\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "858d149fab631b8247aec2a15d6e733d";

module.exports = node;
